/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
/*COMPONENT*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

class GROUP_LIST_DASHBOARD extends Component {
  state = {
    user: {},

    activeTab: "Member",
  };
  componentDidMount() {
    const { pathname } = window.location;
    const found = pathname;
    if (found === "/user_group/group") {
      this.setActiveTab("Group");
    } else {
      this.setActiveTab("Member");
    }
  }
  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const language = localStorage?.language || "ina";
    const { activeTab } = this.state;

    const tabs = [
      { title: "Member", link: "/user_group/collaborator" },
      { title: "Group", link: "/user_group/group" },
    ];
    const navItemStyle = (tab) => ({
      margin: "0 20px",
      paddingBottom: "5px",
      cursor: "pointer",
      fontFamily: "sans-serif",
      fontSize: "16px",
      color: activeTab === tab?.title ? "#007BFF" : "#555",
      fontWeight: activeTab === tab?.title ? "bold" : "normal",
      position: "relative",
      borderBottom:
        activeTab === tab?.title
          ? "3px solid #007BFF"
          : "3px solid transparent",
      transition: "border-bottom 0.3s",
    });

    return (
      <main className="main_container">
        <section className="header_medium" style={{ marginBottom: "20px" }}>
          {dict["Collaboration Group Management"][language]}
        </section>

        <div
          style={{
            display: "flex",
            padding: "10px 0",
          }}
        >
          {tabs.map((tab, idx) => (
            <Link
              to={tab.link}
              key={idx}
              onClick={() => this.setActiveTab(tab)}
              style={navItemStyle(tab)}
              data-mapid="clickGroup"
            >
              {tab.title}
            </Link>
          ))}
        </div>
        <br />

        {this.props.children}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {})(GROUP_LIST_DASHBOARD);
